import { useAuth0 } from '../../auth/authCompat';
import { getLoginReturnTo } from '../../utilities/authUtils';

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();
  return (
    <button
      className="btn btn-primary btn-block"
      onClick={() =>
        loginWithRedirect({
          prompt: 'login',
          appState: { returnTo: getLoginReturnTo() },
        })
      }
      type="button"
    >
      Log In
    </button>
  );
};

export default LoginButton;
